import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n-lite';
import { bindActionCreators } from 'redux';
import * as classroomGroupActions from '../../../actions/classroom/classroomGroupActions';
import * as messageAlert from '../../../actions/messageAlertAction';
import { Modal, Button, Paragraph } from '@netexknowledge/smart-components';
import { MAX_LENGTH_VARIABLES } from '../../../const';
import { Input } from '@netexknowledge/smart-components';

class AddGroupReveal extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.closeModal = this.closeModal.bind(this);
    this.addGroup = this.addGroup.bind(this);
    this.state = {
      groupName: '',
      nCharacters: 0
    };
  }

  static propTypes = {};

  groupNameRef = React.createRef();

  closeModal() {
    const { classroomGroupActions } = this.props;
    classroomGroupActions.setAddGroupIsOpen(false);
  }

  addGroup(e) {
    e.preventDefault();
    const { classroomGroupActions, messageAlert } = this.props;
    const { groupName } = this.state;

    const groupNameMaxLength = MAX_LENGTH_VARIABLES.GROUP_NAME;
    if (groupName.length > groupNameMaxLength) {
      messageAlert.error(
        I18n.t('error.valueLength', { variable: I18n.t('addGroupPopup.placeholder'), length: groupNameMaxLength })
      );
      return;
    }

    if (groupName) {
      classroomGroupActions.addGroup(groupName).then(() => {
        this.setState({ groupName: '', nCharacters: 0 });
        classroomGroupActions.setAddGroupIsOpen(false);
      });
    } else {
      messageAlert.error(I18n.t('groups.emptyName'));
    }
  }

  render() {
    const { addGroupIsOpen } = this.props;
    const { groupName, nCharacters } = this.state;
    const groupNameMaxLength = MAX_LENGTH_VARIABLES.GROUP_NAME;

    return (
      <Modal
        id="add-group"
        title={I18n.t('addGroupPopup.title')}
        active={addGroupIsOpen}
        onClickOutside={this.closeModal}
        children={
          <Input
            ref={this.groupNameInputRef}
            value={groupName}
            label={
              <span style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Paragraph type="span" className="text-grey-700">{I18n.t('addGroupPopup.name')}</Paragraph>
                <Paragraph type="span" className="text-grey-700 p--xs">{`${nCharacters}/${groupNameMaxLength}`}</Paragraph>
              </span>
            }
            onChange={e => {
              const inputValue = e.target.value;
              if (inputValue.length > groupNameMaxLength) {
                e.target.value = inputValue.slice(0, groupNameMaxLength);
              } else {
                this.setState({ groupName: inputValue, nCharacters: inputValue.length });
              }
            }}
            type="text"
            placeholder={I18n.t('addGroupPopup.placeholder')}
            data-cy="newGroupNameInput"
          />
        }
        footer={
          <>
            <Button onClick={this.closeModal} label={I18n.t('common.cancel')}></Button>
            <Button onClick={this.addGroup} primary label={I18n.t('common.add')} data-cy="addGroupButtonModal"></Button>
          </>
        }
      ></Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    addGroupIsOpen: state.group.addGroupIsOpen,
    i18n: state.i18n,
    colors: state.theme.colors
  };
}

function mapDispatchToProps(dispatch) {
  return {
    classroomGroupActions: bindActionCreators(classroomGroupActions, dispatch),
    messageAlert: bindActionCreators(messageAlert, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AddGroupReveal);
